"use client";

import type { Locale } from "@/domain/locale";
import { useTransition, useEffect, useState, Key } from "react";
import { useSession } from "next-auth/react";
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "@/domain/locale";
import { setLanguage } from "@/services/Locale";
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from "@/components/ui/Dropdown";
import { Loading } from "@/components/Loading";
type LocaleDropdownProps = {
  className?: string;
};
const LocaleDropdown = ({
  className
}: LocaleDropdownProps) => {
  const [isPending, startTransition] = useTransition();
  const [currentLocale, setCurrentLocale] = useState<Locale>();
  const {
    data: session,
    update,
    status
  } = useSession();
  const sessionLocale = session?.user.language as Locale | undefined;
  useEffect(() => {
    const locale = (sessionLocale || DEFAULT_LOCALE) as Locale;
    setCurrentLocale(locale);
  }, [sessionLocale]);
  if (status === "loading") return <Loading size="sm" />;
  const handleLocaleChange = (locale: Key) => {
    startTransition(async () => {
      const castedLocale = locale as Locale;
      await setLanguage(castedLocale);
      await update({
        language: castedLocale
      });
      window.location.reload();
    });
  };
  return <Dropdown isDisabled={isPending} className={className} data-sentry-element="Dropdown" data-sentry-component="LocaleDropdown" data-sentry-source-file="LocaleDropdown.tsx">
      <DropdownTrigger className="flex items-center" data-sentry-element="DropdownTrigger" data-sentry-source-file="LocaleDropdown.tsx">
        <span className="cursor-pointer text-sm font-semibold text-brand-primary">
          {currentLocale?.toString().toUpperCase()}
        </span>
      </DropdownTrigger>
      <DropdownMenu disallowEmptySelection selectionMode="single" selectedKeys={currentLocale} onAction={handleLocaleChange} data-sentry-element="DropdownMenu" data-sentry-source-file="LocaleDropdown.tsx">
        {SUPPORTED_LOCALES.map(locale => <DropdownItem key={locale}>{locale.toUpperCase()}</DropdownItem>)}
      </DropdownMenu>
    </Dropdown>;
};
export { LocaleDropdown };